import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "MyColorPicker"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    disabled: { type: Boolean },
    predefine: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

let props = __props;

let model = _useModel<string>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  const _component_el_color_picker = _resolveComponent("el-color-picker")!

  return (_openBlock(), _createBlock(_component_el_color_picker, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
    disabled: __props.disabled,
    predefine: __props.predefine,
    onActiveChange: _cache[1] || (_cache[1] = ($event: any) => (_isRef(model) //@ts-ignore
 ? model.value = $event : model = $event))
  }, null, 8, ["modelValue", "disabled", "predefine"]))
}
}

})